(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            jdgm.customizeBadges();
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
class productPairsRight extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
    }).
    then((response) => {
      var frag = document.createDocumentFragment(),
        fetchedContent = document.createElement('div');
      frag.appendChild(fetchedContent);
      fetchedContent.innerHTML = response;

      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
      if (replacementContent) {
        this.innerHTML = replacementContent.innerHTML;
      }
    });
  }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('.product-form__buynow');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('buy-now', BuyNow);

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };


    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('data-phototview');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }


  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');

/* =========================================================
   HAUS OF DERM — PRODUCT PAGE ENHANCEMENTS
   ========================================================= */
(function () {
  const normalize = function (value) {
    return (value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/:/g, '')
      .trim()
      .toUpperCase();
  };

  const isHeading = function (el) {
    const tag = el && el.tagName ? el.tagName.toUpperCase() : '';
    const value = (el && el.textContent ? el.textContent : '').trim();

    return /^H[1-6]$/.test(tag) ||
      (value.length <= 60 && (el.querySelector('strong, b') || /:$/.test(value)));
  };

  /* Convert Ingredients and Directions into native accordions. */
  function buildProductAccordions() {
    document
      .querySelectorAll('.product-reference-left-details .product-single__description')
      .forEach(function (description) {
        if (description.dataset.hodAccordionsReady === 'true') return;

        const children = Array.from(description.children);
        if (!children.length) return;

        const accordionLabels = ['INGREDIENTS', 'DIRECTIONS'];
        let activeDetails = null;
        let activeBody = null;

        children.forEach(function (el) {
          const label = normalize(el.textContent);
          const match = accordionLabels.find(function (target) {
            return label === target || label === target + 'S';
          });

          if (match) {
            activeDetails = document.createElement('details');
            activeDetails.className = 'hod-product-accordion';

            const summary = document.createElement('summary');
            summary.innerHTML =
              '<span class="hod-product-accordion__title">' + match + '</span>' +
              '<span class="hod-product-accordion__icon" aria-hidden="true"></span>';

            activeBody = document.createElement('div');
            activeBody.className = 'hod-product-accordion__body';

            activeDetails.appendChild(summary);
            activeDetails.appendChild(activeBody);
            description.insertBefore(activeDetails, el);
            el.remove();
            return;
          }

          if (activeDetails && isHeading(el)) {
            activeDetails = null;
            activeBody = null;
          }

          if (activeBody) {
            activeBody.appendChild(el);
          }
        });

        description.dataset.hodAccordionsReady = 'true';
      });
  }

  /* Tag Manufactured By and Caution so they can be styled consistently. */
  function tagProductInfoSections() {
    document
      .querySelectorAll('.product-reference-left-details .product-single__description')
      .forEach(function (description) {
        const children = Array.from(description.children);
        let activeSection = null;

        children.forEach(function (el) {
          const label = normalize(el.textContent);

          if (label === 'MANUFACTURED BY') {
            el.classList.add('hod-manufactured-heading');
            activeSection = 'manufactured';
            return;
          }

          if (label === 'CAUTION') {
            el.classList.add('hod-caution-heading');
            activeSection = 'caution';
            return;
          }

          if (!activeSection) return;

          if (isHeading(el)) {
            activeSection = null;
            return;
          }

          if (activeSection === 'manufactured') {
            el.classList.add('hod-manufactured-copy');
          }

          if (activeSection === 'caution') {
            el.classList.add('hod-caution-copy');
          }
        });
      });
  }

  /* Shopify can render app embeds away from the custom purchase column.
     Move the live widget nodes into the intended locations after they load. */
  function textMatches(el, re) {
    return el && re.test((el.textContent || '').replace(/\s+/g, ' ').trim());
  }

  function moveSubscriptionWidget() {
    const target = document.getElementById('hod-subscription-target');
    if (!target || target.dataset.widgetMoved === 'true') return;

    const selectors = [
      '.shopify_subscriptions_app_block',
      '.shopify_subscriptions_app_container',
      '[class*="shopify_subscriptions_app"]',
      '[class*="subscriptions-app"]'
    ];

    const widget = Array.from(document.querySelectorAll(selectors.join(',')))
      .find(function (el) {
        if (!el || el === target || target.contains(el)) return false;
        return textMatches(
          el,
          /one-time purchase|subscribe\s*(and|&)\s*save|deliver every/i
        );
      });

    if (!widget) return;

    target.innerHTML = '';
    target.appendChild(widget);
    target.dataset.widgetMoved = 'true';
  }

  function moveJudgeMePreviewBadge() {
    const target = document.querySelector(
      '.product-reference-buy-summary .product-reference-rating'
    );

    if (!target || target.dataset.badgeMoved === 'true') return;

    const badge = Array.from(document.querySelectorAll(
      '.jdgm-widget.jdgm-preview-badge, .jdgm-preview-badge, .jdgm-prev-badge'
    )).find(function (el) {
      if (!el || target.contains(el)) return false;
      if (el.closest('#judgeme_product_reviews')) return false;
      return true;
    });

    if (!badge) return;

    const root = badge.matches('.jdgm-widget.jdgm-preview-badge, .jdgm-preview-badge')
      ? badge
      : (badge.closest('.jdgm-widget.jdgm-preview-badge') || badge);

    target.innerHTML = '';
    target.appendChild(root);
    target.dataset.badgeMoved = 'true';
  }

function addReviewsHeading() {
  const reviews =
    document.querySelector('#judgeme_product_reviews') ||
    document.querySelector('.jdgm-widget.jdgm-review-widget');

  if (!reviews || document.querySelector('.hod-reviews-heading')) return;

  const heading = document.createElement('div');
  heading.className = 'hod-reviews-heading';

  heading.innerHTML = `
    <h2>What People are Saying</h2>
  `;

  reviews.parentNode.insertBefore(heading, reviews);
}

  function updateBuyerConsentVisibility() {
    const target = document.getElementById('hod-buyer-consent-container');
    const widget = document.getElementById('hod-subscription-target');
    if (!target || !widget) return;

    // Shopify's selling_plan value is the most reliable indication of a subscription.
    const form = widget.closest('form') || document.querySelector('form[action*="/cart/add"]');
    const planField = form && form.querySelector('[name="selling_plan"]');
    let subscribed = !!(planField && String(planField.value || '').trim());

    // Some versions of the Shopify Subscriptions app update the selling plan
    // asynchronously. Also inspect the selected purchase-option radio.
    if (!subscribed) {
      const radios = Array.from(widget.querySelectorAll('input[type="radio"]'));
      const checked = radios.find(function (radio) { return radio.checked; });
      if (checked) {
        const label = checked.closest('label') ||
          (checked.id && widget.querySelector('label[for="' + CSS.escape(checked.id) + '"]')) ||
          checked.parentElement;
        const optionText = ((label && label.textContent) || '').replace(/\s+/g, ' ').trim();
        subscribed = /subscribe|deliver every|subscription/i.test(optionText) &&
          !/one.time purchase/i.test(optionText);
        // Shopify's purchase-options widget lists one-time first, subscription second.
        if (!optionText && radios.length > 1) subscribed = radios.indexOf(checked) > 0;
      }
    }
    target.classList.toggle('hod-consent-visible', subscribed && !!target.querySelector('#shopify-buyer-consent'));
  }

  function moveBuyerConsent() {
    const target = document.getElementById('hod-buyer-consent-container');
    const consent = document.getElementById('shopify-buyer-consent');
    if (!target) return;
    if (consent && !target.contains(consent)) target.appendChild(consent);
    updateBuyerConsentVisibility();
  }

  function placeAppWidgets() {
  moveBuyerConsent();
  moveSubscriptionWidget();
  moveJudgeMePreviewBadge();
  addReviewsHeading();
}

  /* Reliable sticky-gallery fallback for themes whose ancestor styles
     prevent native position: sticky from behaving consistently. */
  function initStickyGallery() {
    const media = document.querySelector('.product-reference-showcase__media');
    const showcase = document.querySelector('.product-reference-showcase');

    if (!media || !showcase) return;

    const desktopMq = window.matchMedia('(min-width: 768px)');
    let ticking = false;

    function resetGallery() {
      media.style.removeProperty('transform');
      media.style.removeProperty('will-change');
    }

    function updateGallery() {
      ticking = false;

      if (!desktopMq.matches) {
        resetGallery();
        return;
      }

      media.style.transform = 'none';

      const mediaRect = media.getBoundingClientRect();
      const initialTop = mediaRect.top + window.scrollY;
      const mediaHeight = mediaRect.height;

      const reviewEl =
        document.querySelector('#judgeme_product_reviews') ||
        document.querySelector('[id*="judgeme"][id*="review"]');

      const stopY = reviewEl
        ? reviewEl.getBoundingClientRect().top + window.scrollY
        : showcase.getBoundingClientRect().bottom + window.scrollY;

      const stickyTop = 92;
      const stopGap = 28;
      const desiredOffset = Math.max(0, window.scrollY + stickyTop - initialTop);
      const maxOffset = Math.max(
        0,
        stopY - stopGap - mediaHeight - initialTop
      );

      const offset = Math.min(desiredOffset, maxOffset);

      media.style.transform = 'translate3d(0,' + offset + 'px,0)';
      media.style.willChange = 'transform';
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateGallery);
    }

    requestUpdate();
    [150, 400, 800, 1400].forEach(function (delay) {
      setTimeout(requestUpdate, delay);
    });

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  document.addEventListener('DOMContentLoaded', function () {
    buildProductAccordions();
    tagProductInfoSections();
    placeAppWidgets();
    initStickyGallery();

    document.addEventListener('change', function (event) {
      if (event.target.matches('input[name="selling_plan"], #hod-subscription-target input')) {
        updateBuyerConsentVisibility();
        setTimeout(updateBuyerConsentVisibility, 80);
      }
    });
    document.addEventListener('click', function (event) {
      if (event.target.closest('#hod-subscription-target')) {
        setTimeout(updateBuyerConsentVisibility, 80);
      }
    });

    [100, 300, 600, 1000, 1600, 2500].forEach(function (delay) {
      setTimeout(placeAppWidgets, delay);
    });

    const observer = new MutationObserver(function () {
      placeAppWidgets();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(function () {
      observer.disconnect();
    }, 6000);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
